<template>
  <v-container>
    <Navigation
      :items="items"
    />
  </v-container>
</template>

<script>
import Navigation from '@/views/components/Navigation.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'School',
  components: {
    Navigation
  },
  computed: {
    ...mapGetters([
      'menuData'
    ]),
    items () {
      return this.menuData.school.elements
        .map(id => this.menuData[id])
        .sort((a, b) => a.position - b.position)
    }
  }
}
</script>

<style>
  .v-card, .v-card .v-avatar {
    transition: box-shadow .2s ease-in-out;
  }
</style>
